import { render, staticRenderFns } from "./checklist-files.vue?vue&type=template&id=dab1b966&scoped=true"
import script from "./checklist-files.vue?vue&type=script&lang=js"
export * from "./checklist-files.vue?vue&type=script&lang=js"
import style0 from "./checklist-files.vue?vue&type=style&index=0&id=dab1b966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab1b966",
  null
  
)

export default component.exports